import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { automations } from 'modules/automations/store/collections/automations'

const AutomationsRootPage = React.lazy(
  () => import('modules/automations/pages/settings/AutomationsRootPage')
)

const AddAutomationBlockModalPage = React.lazy(
  () => import('modules/automations/pages/settings/AddAutomationBlockModalPage')
)

const AuthorizedAutomationsListPage = React.lazy(
  () => import('modules/automations/pages/settings/AuthorizedAutomationsListPage')
)

const AutomationsShowRootPage = React.lazy(
  () => import('modules/automations/pages/settings/AutomationsShowRootPage')
)
const DeleteActionModalPage = React.lazy(
  () => import('modules/automations/pages/settings/DeleteActionModalPage')
)

const DeleteAutomationModalPage = React.lazy(
  () => import('modules/automations/pages/settings/DeleteAutomationModalPage')
)

const DetailsPage = React.lazy(() => import('modules/automations/pages/settings/DetailsPage'))

const EditDateAutomationModalPage = React.lazy(
  () => import('modules/automations/pages/settings/EditDateAutomationModalPage')
)

const HistoryPage = React.lazy(() => import('modules/automations/pages/settings/HistoryPage'))
const NewAutomationModalPage = React.lazy(
  () => import('modules/automations/pages/settings/NewAutomationModalPage')
)
const RedirectToDetailsPage = React.lazy(
  () => import('modules/automations/pages/settings/RedirectToDetailsPage')
)

const RedirectToListPage = React.lazy(
  () => import('modules/automations/pages/settings/RedirectToListPage')
)

const RenameAutomationModalPage = React.lazy(
  () => import('modules/automations/pages/settings/RenameAutomationModalPage')
)

const AutomationsShowHeader = React.lazy(
  () => import('modules/automations/pages/settings/details/Header')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.automations.path,
      element: <AutomationsRootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('automations.automations'),
        }),
      },
      children: [
        {
          index: true,
          element: <RedirectToListPage />,
        },
        {
          path: navigation.settings.automations.list.path,
          element: <AuthorizedAutomationsListPage />,
          children: [
            {
              path: navigation.settings.automations.list.new.path,
              element: <NewAutomationModalPage />,
            },
          ],
        },
        {
          path: navigation.settings.automations.id.path,
          element: <AutomationsShowRootPage />,
          handle: {
            resource: true,
            meta: async ({ params, navigate }) => {
              const automation = await (async () => {
                const automationFromId = automations.get(params['id'])

                if (automationFromId) return automationFromId

                await automations.fetch()

                return automations.get(params['id'])
              })()

              if (!automation) {
                navigate(navigation.settings.automations.list.fullPath())

                return
              }

              return {
                subNavigation: [
                  {
                    title: i18n.t('automations.meta_data.details_title'),
                    href: navigation.settings.automations.id.details.fullPath({
                      id: String(params['id']),
                    }),
                  },
                  {
                    title: i18n.t('automations.meta_data.history_title'),
                    href: navigation.settings.automations.id.history.fullPath({
                      id: String(params['id']),
                    }),
                  },
                ],
                title: automation.attributes.name,
                headerComponent: <AutomationsShowHeader automation={automation} />,
              }
            },
          },
          children: [
            {
              index: true,
              element: <RedirectToDetailsPage />,
            },
            {
              path: navigation.settings.automations.id.details.path,
              element: <DetailsPage />,

              children: [
                {
                  path: navigation.settings.automations.id.details.rename.path,
                  element: <RenameAutomationModalPage />,
                },
                {
                  path: navigation.settings.automations.id.details.editDate.path,
                  element: <EditDateAutomationModalPage />,
                },
                {
                  path: navigation.settings.automations.id.details.delete.path,
                  element: <DeleteAutomationModalPage />,
                },
                {
                  path: navigation.settings.automations.id.details.addBlockParentId.path,
                  element: <AddAutomationBlockModalPage />,
                },
                {
                  path: navigation.settings.automations.id.details.actionsActionIdDelete.path,
                  element: <DeleteActionModalPage />,
                },
              ],
            },
            {
              path: navigation.settings.automations.id.history.path,

              element: <HistoryPage />,
              children: [
                {
                  path: navigation.settings.automations.id.history.delete.path,
                  element: <DeleteAutomationModalPage />,
                },
                {
                  path: navigation.settings.automations.id.history.rename.path,
                  element: <RenameAutomationModalPage />,
                },
              ],
            },
          ],
        },
      ],
    },
  ]
}

export default settingsRoutes
